import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_FETCH_USER_TRANSACTIONS } from "../../../config/api";

export const fetchTransactions = createAsyncThunk(
  "transaction/getAll",
  async ({ id, currency }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: currency
          ? `${API_FETCH_USER_TRANSACTIONS}${id}/${currency}`
          : `${API_FETCH_USER_TRANSACTIONS}${id}`,
      });

      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(msg);
    }
  },
);
